// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DateFNS from 'date-fns';
import DateFNSPT from 'date-fns/locale/pt';
import _ from 'lodash';
import { Icon } from 'semantic-ui-react';
// local
import './DateContent.scss';
// lib
import { fromUTC, isValidDate } from 'app/lib/helper';

class DateContent extends Component {
    constructor(props) {
        super(props);
        let value = props.value;
        value = isValidDate(value) ? value : new Date();
        let state = this.initState(fromUTC(value, true));
        this.state = {
            ...state,
            value,
        };
    }

    componentWillReceiveProps(nextProps) {
        const { value: oldValue } = this.state;
        const { value: newValue } = nextProps;
        if (newValue != null && !this.isEqual(oldValue, newValue)) {
            let state = this.initState(newValue);
            this.setState({
                ...state,
                value: newValue,
            });
        }
    }

    initState(current) {
        let today = fromUTC(new Date(), true);
        let firstDay = DateFNS.setDay(DateFNS.setDate(current, 1), 0);
        let lastDay = DateFNS.setDay(DateFNS.lastDayOfMonth(current), 6);
        return {
            current,
            today,
            dates: this.initDays(firstDay, lastDay),
        };
    }

    isEqual(date1, date2) {
        return date1.getUTCFullYear() === date2.getUTCFullYear() && date1.getUTCMonth() === date2.getUTCMonth() && date1.getUTCDate() === date2.getUTCDate();
    }

    isAfter(date1, date2) {
        if (date1.getUTCFullYear() > date2.getUTCFullYear()) {
            return true;
        } else if (date1.getUTCFullYear() === date2.getUTCFullYear()) {
            if (date1.getUTCMonth() > date2.getUTCMonth()) {
                return true;
            } else if (date1.getUTCMonth() === date2.getUTCMonth()) {
                return date1.getUTCDate() > date2.getUTCDate();
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    // printDate(date) {
    //     console.log(`${date.getUTCDate()}|${date.getUTCMonth()}|${date.getUTCFullYear()}`);
    // }

    initDays(firstDay, lastDay) {
        let days = [];
        let current = firstDay;
        let isLastDay = false;
        let i = 0;
        do {
            if (this.isEqual(current, lastDay)) {
                isLastDay = true;
            }
            days.push(current);
            current = DateFNS.addDays(current, 1);
            i++;
            if (i >= 50) {
                // safe exit in case the date is invalid
                break;
            }
        } while (!isLastDay);
        return days;
    }

    onSelectDate = day => () => {
        const { onSelectDate } = this.props;
        if (onSelectDate) {
            onSelectDate(day);
        }
        let state = this.initState(day);
        this.setState({
            ...state,
        });
    };

    onClickBack = () => {
        let { current } = this.state;
        current = DateFNS.addMonths(current, -1);
        let state = this.initState(current);
        this.setState(state);
    };

    onClickNext = () => {
        let { current } = this.state;
        current = DateFNS.addMonths(current, 1);
        let state = this.initState(current);
        this.setState(state);
    };

    render() {
        const { value, current, today, dates } = this.state;

        return (
            <React.Fragment>
                <div className="header">
                    <div className="buttons">
                        <div className="back">
                            <Icon name="chevron left" onClick={this.onClickBack} />
                        </div>
                        <div className="year">{DateFNS.format(current, 'MMM YYYY', { locale: DateFNSPT })}</div>
                        <div className="next">
                            <Icon name="chevron right" onClick={this.onClickNext} />
                        </div>
                    </div>
                    <div className="days">
                        <div>D</div>
                        <div>S</div>
                        <div>T</div>
                        <div>Q</div>
                        <div>Q</div>
                        <div>S</div>
                        <div>S</div>
                    </div>
                </div>
                <div className="dates">
                    {_.map(dates, day => {
                        const sameMonthClass = DateFNS.isSameMonth(day, current) ? 'same-month' : '';
                        const todayClass = this.isEqual(day, today) ? 'today' : '';
                        const sameDayClass = this.isEqual(day, value) ? 'current' : '';
                        const afterTodayClass = this.isAfter(day, today) ? 'after' : '';
                        const classes = [sameMonthClass, todayClass, sameDayClass, afterTodayClass].filter(c => c.length > 0).join(' ');
                        const key = String(DateFNS.getTime(day));
                        return (
                            <div key={key} onClick={this.isAfter(day, today) ? null : this.onSelectDate(day)} className={classes}>
                                {DateFNS.getDate(day)}
                            </div>
                        );
                    })}
                </div>
            </React.Fragment>
        );
    }
}

DateContent.propTypes = {
    id: PropTypes.string,
    value: PropTypes.object,
    onSelectDate: PropTypes.func,
};

export default DateContent;
